export enum ClaimStatus {
  FeeForService = 'feeForService',
  PMPM = 'pmpm',
  ValueBased = 'valueBased',
  Grant = 'grant',
  NotBillable = 'notBillable',
}
